module.exports = __webpack_public_path__ + "assets/img/timeline__img-3.773bd33a.svg";